<script>
import { Cell } from 'vant'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-config-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchGroup: {
                // matchId: null,
                id: null,
                teamSignupItems: null,
                memberSignupItems: null,
                teamNumLabel: null,
                genderRestrictionLabel: null,
                isGenderNumShow: null,
                maleNumLabel: null,
                femaleNumLabel: null,
                ageRestrictionLabel: null,
                isStaffOn: null,
                staffNumLabel: null,
                staffDutyItems: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onTeamConfigBtnClick() {
            console.log('onTeamConfigBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSignupTeamConfig',
                    params: {
                        id: this.matchGroup.id
                    },
                }
            })
        },
        onMemberConfigBtnClick() {
            console.log('onMemberConfigBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSignupMemberConfig',
                    params: {
                        id: this.matchGroup.id
                    },
                }
            })
        },
        onContestantConfigBtnClick() {
            console.log('onContestantConfigBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSignupContestantConfig',
                    params: {
                        id: this.matchGroup.id
                    },
                }
            })
        },
        onStaffConfigBtnClick() {
            console.log('onStaffConfigBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'OrgEditMatchSignupStaffConfig',
                    params: {
                        id: this.matchGroup.id
                    },
                }
            })
        },
    },
}
</script>

<template>
    <div class="match-signup-config-detail">
        <div class="u-outer-padding">
            <span class="main-text">{{ locale['team-signup-data'] }}</span>
            <span class="pull-right vertical-center" @click="onTeamConfigBtnClick">
                <span class="normal-text">{{ locale['config'] }}</span>
                <span><i class="iconfont iconfont-right"/></span>
            </span>
        </div>
        <div class="bg-white">
            <div class="wrapper">
                <div class="u-outer-padding">
                    <div 
                        v-for="item in matchGroup.teamSignupItems" 
                        :key="item.value"
                        class="inline-block r-outer-margin"
                    >
                        <div class="bg-primary corner-round-sm b-narrow-margin">
                            <div class="u-narrow-padding">
                                <span class="minor-text color-white">{{ item.label }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="u-outer-padding">
            <span class="main-text">{{ locale['member-signup-data'] }}</span>
            <span class="pull-right vertical-center" @click="onMemberConfigBtnClick">
                <span class="normal-text">{{ locale['config'] }}</span>
                <span><i class="iconfont iconfont-right"/></span>
            </span>
        </div>
        <div class="bg-white">
            <div class="wrapper">
                <div class="u-outer-padding">
                    <div 
                        v-for="item in matchGroup.memberSignupItems" 
                        :key="item.value"
                        class="inline-block r-outer-margin"
                    >
                        <div class="bg-primary corner-round-sm b-narrow-margin">
                            <div class="u-narrow-padding">
                            <span class="minor-text color-white">{{ item.label }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="u-outer-padding">
            <span class="main-text">{{ locale['contestant-signup-data'] }}</span>
            <span class="pull-right vertical-center" @click="onContestantConfigBtnClick">
                <span class="normal-text">{{ locale['config'] }}</span>
                <span><i class="iconfont iconfont-right"/></span>
            </span>
        </div>
        <div class="bg-white">
            <van-cell
                :title="locale['team-number']"
                :value="matchGroup.teamNumLabel"
            />
            <van-cell
                :title="locale['gener-restriction']"
                :value="matchGroup.genderRestrictionLabel"
            />
            <van-cell v-if="matchGroup.isGenderNumShow"
                :title="locale['male-member-number']"
                :value="matchGroup.maleNumLabel"
            />
            <van-cell v-if="matchGroup.isGenderNumShow"
                :title="locale['female-member-number']"
                :value="matchGroup.femaleNumLabel"
            />
            <van-cell
                :title="locale['age-restriction']"
                :value="matchGroup.ageRestrictionLabel"
            />
        </div>
        <div class="u-outer-padding">
            <span class="main-text">{{ locale['staff-signup-data'] }}</span>
            <span class="pull-right vertical-center" @click="onStaffConfigBtnClick">
                <span class="normal-text">{{ locale['config'] }}</span>
                <span><i class="iconfont iconfont-right"/></span>
            </span>
        </div>
        <div class="bg-white">
            <div v-if="matchGroup.isStaffOn">
                <van-cell
                    :title="locale['staff-number']"
                    :value="matchGroup.staffNumLabel"
                />
                <div class="bg-white t-outer-margin">
                    <div class="label u-inner-padding">
                        <span class="main-text main-secondary-color">{{ locale['signup-staff-role'] }}</span>
                    </div>
                    <div class="wrapper">
                        <div class="u-outer-padding">
                            <div 
                                v-for="item in matchGroup.staffDutyItems" 
                                :key="item"
                                class="inline-block r-outer-margin"
                            >
                                <div class="bg-primary corner-round-sm b-narrow-margin">
                                    <div class="u-narrow-padding">
                                        <span class="minor-text color-white">{{ item }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="h-wide-padding text-center">
                <span class="normal-text minor-color">{{ locale['staff-signup-off-hint'] }}</span>
            </div>
        </div>
    </div>
</template>